import { DefaultButton, Dialog, DialogFooter, PrimaryButton, Stack, Text, TextField } from '@fluentui/react';
import { EUnderwritingConfirmationDialogState } from './CompareContext.helpers';

interface IUnderwritingConfirmationDialogProps {
    state: EUnderwritingConfirmationDialogState;
    correctionComment: string;
    onCorrectionCommentChange: (value: string) => void;
    onContinue: () => void;
    onCancel: () => void;
}

const UnderwritingConfirmationDialog: React.FC<IUnderwritingConfirmationDialogProps> = (props) => {
    let title = "";

    switch (props.state) {
        case EUnderwritingConfirmationDialogState.Approve:
            title = "Confirm Changes?";
            break;

        case EUnderwritingConfirmationDialogState.Corrections:
            title = "Return for corrections?";
            break;

        case EUnderwritingConfirmationDialogState.Save:
            title = "Save Changes?";
            break;

        default:
            title = "";
    }

    let primaryButtonText = "";
    switch (props.state) {
        case EUnderwritingConfirmationDialogState.Approve:
            primaryButtonText = "Yes, Accept";
            break;
        case EUnderwritingConfirmationDialogState.Corrections:
            primaryButtonText = "Yes, Return for corrections";
            break;
        case EUnderwritingConfirmationDialogState.Save:
            primaryButtonText = "Yes, Save";
            break;
        default:
            primaryButtonText = "";
    }

    return (
        <Dialog
            minWidth={800}
            hidden={props.state === EUnderwritingConfirmationDialogState.Hidden}
            onDismiss={props.onCancel}
            dialogContentProps={{ title }}
        >
            <Stack tokens={{ childrenGap: 10 }}>
                {props.state === EUnderwritingConfirmationDialogState.Approve && (
                    <>
                        <Text>Are you sure you want to accept/approve these changes?</Text>
                        <Text>This will move target snapshot to Underwriting Review Complete.</Text>
                    </>
                )}
                {props.state === EUnderwritingConfirmationDialogState.Corrections && (
                    <>
                        <Text>Are you sure you want to reject these changes?</Text>
                        <Text>This will move target snapshot to Corrections Pending, allowing data entry to make changes.</Text>
                    </>
                )}
                {props.state === EUnderwritingConfirmationDialogState.Save && (
                    <Text>This will save changes to the target snapshot.</Text>
                )}
                <TextField
                    label="Comments (optional)"
                    value={props.correctionComment}
                    maxLength={4000}
                    multiline
                    autoAdjustHeight
                    onChange={(event, newValue) => props.onCorrectionCommentChange(newValue ?? "")}
                />
            </Stack>

            <DialogFooter>
                <PrimaryButton
                    onClick={props.onContinue}
                    text={primaryButtonText}
                    disabled={false}
                />

                <DefaultButton
                    onClick={props.onCancel}
                    text={"Cancel"}
                    disabled={false}
                />
            </DialogFooter>
        </Dialog>
    );
};

export default UnderwritingConfirmationDialog;
